<mat-dialog-content class="default-dialog-content primary-text">
	<p>
		The Booking Assistant automation works better when carriers know it is coming. We would like to
		email the carriers in your network to let them know you will be using Booking Assistant and to
		explain the process to them.
	</p>

	<p>Please confirm we can contact the carriers on your behalf.</p>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action" fxLayoutAlign="end center" fxLayoutGap="2rem">
	<span
		(click)="closeDialog({eventName: SegmentEventsConstants.user_opted_out_carrier_warmup, isCarrierWarmupConfirmed: false})"
		class="link"
		>Skip</span
	>

	<button
		(click)="closeDialog({eventName: SegmentEventsConstants.user_confirmed_carrier_warmup, isCarrierWarmupConfirmed: true})"
		color="primary"
		mat-raised-button
	>
		CONFIRM
	</button>
</mat-dialog-actions>
